import React, { useEffect, useRef } from "react"
import "../styles/App.scss"
import Chart from "chart.js"

let myChart

const ChartOne = ({ value, weekIndex }) => {
  const percent = useRef()

  useEffect(() => {
    let ctx = document.getElementById("chart")
    ctx.height = 110
    ctx.width = 175

    if (typeof myChart !== "undefined") myChart.destroy()

    myChart = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: [
          "Registro de Personal de IMSS",
          "Verificación Médica incluido COVID",
          "Equipo de protección personal",
          "Certificados DC3 en actividades",
          "Calidad de la maquinaria y herramienta",
          "Uso adecuado",
          "Mantenimiento",
          "Limpieza y Orden",
          "Señaletica",
          "Procesos Constructivos",
        ],
        datasets: value,
      },
      options: {
        legend: {
          position: "right",
          labels: {
            fontSize: 10,
            fontColor: "black",
            fontFamily: "Arial, sans-serif",
          },
        },
      },
    })
  }, [myChart])

  return (
    <>
      <div className="elements">
        <div className="chart-container">
          <h5
            style={{
              zIndex: "1",
              position: "absolute",
              margin: "0",
            }}
          >
            {weekIndex}%
          </h5>
          <canvas id="chart"></canvas>
        </div>
      </div>
    </>
  )
}

export default ChartOne
